const CanceledReservationsActionTypes = {};

CanceledReservationsActionTypes.FETCH_ALL_CANCELED_RESERVATIONS = 'FETCH_ALL_CANCELED_RESERVATIONS';
CanceledReservationsActionTypes.FETCH_CANCELED_RESERVATIONS = 'FETCH_CANCELED_RESERVATIONS';
CanceledReservationsActionTypes.ADD_CANCELED_RESERVATIONS = 'ADD_CANCELED_RESERVATIONS';
CanceledReservationsActionTypes.EDIT_CANCELED_RESERVATIONS = 'EDIT_CANCELED_RESERVATIONS';
CanceledReservationsActionTypes.DELETE_CANCELED_RESERVATIONS = 'DELETE_CANCELED_RESERVATIONS';

export default CanceledReservationsActionTypes;
